import { computed, type ComputedRef } from 'vue'

type Environment = 'production' | 'development'

const DEVELOPMENT_KEYWORDS = ['dev', 'uat'] as const

interface EnvironmentReturn {
  hostname: ComputedRef<string>
  isProduction: ComputedRef<boolean>
  isDevelopment: ComputedRef<boolean>
  environment: ComputedRef<Environment>
}

export const useEnvironment = (): EnvironmentReturn => {
  const hostname = computed<string>(() => window.location.hostname)

  const isProduction = computed<boolean>(() => {
    const host = hostname.value.toLowerCase()
    const isDev = DEVELOPMENT_KEYWORDS.some((keyword) => host.includes(keyword))
    return !isDev
  })

  const environment = computed<Environment>(() =>
    isProduction.value ? 'production' : 'development'
  )

  const isDevelopment = computed<boolean>(() => !isProduction.value)

  return {
    hostname,
    isProduction,
    isDevelopment,
    environment,
  }
}
